import { getStorage, ref as storageRef, getDownloadURL } from "firebase/storage";
import React, {useEffect, useState} from "react";
import spinner from '../Images/spinner.gif'
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import {PhotoModel} from "../types/protocols";

interface ClickableImageProps {
    photo: PhotoModel;
    buildingKey: string;
    altText?: string;
    size?: number;
    disableClick?: boolean;
    thumbnail?: boolean;
    showDate?: boolean;
    onImageClick?: (photo: PhotoModel, fullUrl: string) => void;
    highlighted?: boolean;
}

const ClickableImage: React.FC<ClickableImageProps> = ({
                                                           photo,
                                                           buildingKey,
                                                           altText = "Component Photo",
                                                           size = 125,
                                                           disableClick = false,
                                                           thumbnail = true,
                                                           showDate = size > 80 && photo.date.length !== 0,
                                                           onImageClick,
                                                           highlighted = false,
                                                       }) => {

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        if (disableClick) return;

        if (onImageClick) {
            onImageClick(photo, photo.fullSizeUrl)
            return;
        }

        Fancybox.show(
            [
                {
                    src: photo.fullSizeUrl,
                    caption: photo.date,
                }
            ],
            {
                animated: true,
                showClass: "fancybox-fadeIn",
            }
        );
    };

    return (
        <div
            style={{
                position: 'relative',
                width: size,
                height: size,
                borderRadius: '5px',
                overflow: 'hidden',
            }}
        >
            {highlighted &&
                <div style={{position: 'absolute', backgroundColor: '#FFFFFFAA', width: '100%', height: '100%'}}/>
            }
            <a
                href={photo.fullSizeUrl}
                data-fancybox="gallery"
                data-caption={photo.date}
                onClick={handleClick}
                style={{
                    display: 'block',
                    width: '100%',
                    height: '100%',
                }}
            >
                <img
                    key={photo.key}
                    src={thumbnail ? photo.smallSizeUrl : photo.mediumSizeUrl}
                    alt={altText}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        cursor: disableClick ? 'default' : 'pointer',
                    }}
                />



            </a>
            {showDate && (
                <div
                    style={{
                        position: 'absolute',
                        bottom: '0',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '100%',
                        textAlign: 'center',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        color: '#fff',
                        padding: '5px 0',
                        borderBottomLeftRadius: '5px',
                        borderBottomRightRadius: '5px',
                        fontSize: '14px',
                        zIndex: '99',
                    }}
                >
                    {photo.date.split(" ")[0]}
                </div>
            )}

        </div>
    );
};

export default ClickableImage;
